import { Toast } from 'vant'
import wx from 'weixin-js-sdk'
import Cookies from 'js-cookie'
import moment from 'moment'
import { stringify } from 'qs'

const TokenKey = 'Admin-Token'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

let util = {
  // 根据当前时间后推date月数
  getMonthDate(date) {
    let now = new Date()
    let year = now.getFullYear()
    let month = now.getMonth() + 1 // 0-11表示1-12月
    let day = now.getDate()
    let dateObj = {}
    if (parseInt(month) < 10) {
      month = '0' + month
    }
    if (parseInt(day) < 10) {
      day = '0' + day
    }

    dateObj.now = year + '-' + month + '-' + day

    if (parseInt(month) === 1) {
      // 如果是1月份，则取上一年的10月份
      dateObj.last = parseInt(year) - 1 + '-10-' + day
      return dateObj
    }
    if (parseInt(month) === 2) {
      // 如果是2月份，则取上一年的11月份
      dateObj.last = parseInt(year) - 1 + '-11-' + day
      return dateObj
    }
    if (parseInt(month) === 3) {
      // 如果是3月份，则取上一年的12月份
      dateObj.last = parseInt(year) - 1 + '-12-' + day
      return dateObj
    }

    let preSize = new Date(year, parseInt(month) - date, 0).getDate() // 开始时间所在月的总天数
    if (preSize < parseInt(day)) {
      // 开始时间所在月的总天数<本月总天数，比如当前是5月30日，在2月中没有30，则取下个月的第一天(3月1日)为开始时间
      let resultMonth = parseInt(month) - 2 < 10 ? '0' + parseInt(month) - 2 : parseInt(month) - 2
      dateObj.last = year + '-' + resultMonth + '-01'
      return dateObj
    }

    if (parseInt(month) <= 10) {
      dateObj.last = year + '-0' + (parseInt(month) - date) + '-' + day
      return dateObj
    } else {
      dateObj.last = year + '-' + (parseInt(month) - date) + '-' + day
      return dateObj
    }
  },
  // 订单状态
  orderState(state, sts) {
    // 订单状态 1待付款 2待发货3已发货4已关闭5已完成6售后
    let status = { text: '待付款', icon: 'daizhifu' }
    switch (state) {
      case 1:
        status = { text: '待付款', icon: 'daizhifu' }
        break
      case 2:
        status = { text: '待发货', icon: 'daishouhuo' }
        break
      case 3:
        status = { text: '已发货', icon: 'daishouhuo' }
        break
      case 4:
        status = { text: '已关闭', icon: 'daishouhuo' }
        break
      case 5:
        status = { text: '已完成', icon: 'daizhifu' }
        break
      case 6:
        status = { text: '售后', icon: 'daizhifu' }
        switch (sts) {
          // 状态 1待审核 2待上传物流 3待退款 4已退款 5已过期 6审核拒绝 7拒绝退款
          case 1:
            status = { text: '待审核', icon: 'daizhifu' }
            break
          case 2:
            status = { text: '待上传物流', icon: 'daizhifu' }
            break
          case 3:
            status = { text: '待退款', icon: 'daizhifu' }
            break
          case 4:
            status = { text: '已退款', icon: 'daizhifu' }
            break
          case 5:
            status = { text: '已过期', icon: 'daizhifu' }
            break
          case 6:
            status = { text: '审核拒绝', icon: 'daizhifu' }
            break
          case 7:
            status = { text: '拒绝退款', icon: 'daizhifu' }
            break
          case 8:
            status = { text: '已完成', icon: 'daizhifu' }
            break
        }
        break
    }
    return status
  },

  // 积分状态
  integralState(state) {
    let stateName
    switch (state) {
      case 0:
        stateName = '冻结账户'
        break
      case 1:
        stateName = '可用账户'
        break
    }
    return stateName
  },

  // 积分标题状态
  integralTitleState(state) {
    let stateName
    switch (state) {
      case 0:
        stateName = '收入'
        break
      case 1:
        stateName = '支出'
        break
      case 2:
        stateName = '转出'
        break
      case 3:
        stateName = '退款'
        break
    }
    return stateName
  },
  // 现金标题状态
  moneyTitleState(state) {
    let stateName
    switch (state) {
      case '0':
        stateName = '支出'
        break
      case '1':
        stateName = '退款'
        break
      // case 2:
      //   stateName = '转出'
      //   break
      // case 3:
      //   stateName = '退款'
      //   break
    }
    return stateName
  },
  // 格式化时间
  dateFormater(value) {
    let date = new Date(value)
    let y = date.getFullYear()
    let MM = date.getMonth() + 1
    MM = MM < 10 ? '0' + MM : MM
    let d = date.getDate()
    d = d < 10 ? '0' + d : d
    let h = date.getHours()
    h = h < 10 ? '0' + h : h
    let m = date.getMinutes()
    m = m < 10 ? '0' + m : m
    let s = date.getSeconds()
    s = s < 10 ? '0' + s : s
    return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s
  },

  // 去除数组中的空值
  trimNull(array) {
    for (let i = 0; i < array.length; i++) {
      if (array[i] === '' || typeof array[i] === 'undefined') {
        array.splice(i, 1)
        i = i - 1
      }
    }
    return array
  },

  // weChat支付
  wexinPay(data, cb, errorCb) {
    // 获取后台传入的数据
    let appId = data.appId
    let timestamp = data.timeStamp
    let nonceStr = data.nonceStr
    let signature = data.signature
    let packages = data.package
    let paySign = data.paySign
    let signType = data.signType
    console.log('发起微信支付')
    // 下面要发起微信支付了
    wx.config({
      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: appId, // 必填，公众号的唯一标识
      timestamp: timestamp, // 必填，生成签名的时间戳
      nonceStr: nonceStr, // 必填，生成签名的随机串
      signature: signature, // 必填，签名，见附录1
      jsApiList: ['chooseWXPay'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
    })
    wx.ready(function() {
      wx.chooseWXPay({
        timestamp: timestamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
        nonceStr: nonceStr, // 支付签名随机串，不长于 32 位
        package: packages, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=***）
        signType: signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
        paySign: paySign, // 支付签名
        success: function(res) {
          // 支付成功后的回调函数
          cb(res)
        },
        fail: function(res) {
          // 失败回调函数
          errorCb(res)
        }
      })
    })
    wx.error(function(res) {
      // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
      Toast('验证失败')
    })
  },

  // 节流函数(指定时间间隔内只会执行一次任务。)
  throttle(fn) {
    // 4、通过闭包保存一个标记
    let canRun = true
    return function() {
      // 5、在函数开头判断标志是否为 true，不为 true 则中断函数
      if (!canRun) {
        return
      }
      // 6、将 canRun 设置为 false，防止执行之前再被执行
      canRun = false
      // 7、定时器
      setTimeout(() => {
        fn.call(this, arguments)
        // 8、执行完事件（比如调用完接口）之后，重新将这个标志设置为 true
        canRun = true
      }, 1000)
    }
  },

  getUrlKey(name, url) {
    return (
      decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(url) || [, ''])[1].replace(/\+/g, '%20')) || null
    )
  },

  // 防抖函数(任务频繁触发的情况下，只有任务触发的间隔超过指定间隔的时候，任务才会执行。)
  debounce(fn) {
    // 4、创建一个标记用来存放定时器的返回值
    let timeout = null
    return function() {
      // 5、每次当用户点击/输入的时候，把前一个定时器清除
      clearTimeout(timeout)
      // 6、然后创建一个新的 setTimeout，
      // 这样就能保证点击按钮后的 interval 间隔内
      // 如果用户还点击了的话，就不会执行 fn 函数
      timeout = setTimeout(() => {
        fn.call(this, arguments)
      }, 30000)
    }
  },
  formatDate(value, formatStr, formatToStr) {
    return moment(value).format(formatStr)
  },

  /**
   *Base64字符串转二进制
   */
  dataURLtoBlob(dataurl) {
    let arr = dataurl.split(',')
    let mime = arr[0].match(/:(.*?);/)[1]
    let bstr = atob(arr[1])
    let n = bstr.length
    let u8arr = new Uint8Array(n)
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n)
    }
    return new Blob([u8arr], {
      type: mime
    })
  },

  cleanObj(obj) {
    Object.keys(obj).forEach(key => {
      if (!obj[key] || obj[key] === '') {
        delete obj[key]
      }
    })
    return obj
  },

  checkBaiduOrc(json) {
    if (json.image_status === 'normal') {
      return true
    } else {
      // Toast.fail('识别失败，请重试！');
      if (json.image_status === 'reversed_side') {
        return '识别失败，身份证正反面颠倒'
      } else if (json.image_status === 'non_idcard') {
        return '识别失败，上传的图片中不包含身份证'
      } else if (json.image_status === 'blurred') {
        return '识别失败，身份证模糊'
      } else if (json.image_status === 'other_type_card') {
        return '识别失败，其他类型证照'
      } else if (json.image_status === 'over_exposure') {
        return '识别失败，身份证关键字段反光或过曝'
      } else if (json.image_status === 'over_dark') {
        return '识别失败，身份证欠曝（亮度过低）'
      } else {
        return '身份证识别失败，请重试！'
      }
    }
  },

  // 压缩图像并返回Base64编码数据
  compressImageToBase64(file, maxWidth, maxHeight, quality) {
    return new Promise((resolve, reject) => {
      const img = new Image()

      img.onload = () => {
        const canvas = document.createElement('canvas')
        let { width, height } = img

        // 计算图像的缩放尺寸
        if (width > maxWidth) {
          height = (height * maxWidth) / width
          width = maxWidth
        }

        if (height > maxHeight) {
          width = (width * maxHeight) / height
          height = maxHeight
        }

        canvas.width = width
        canvas.height = height

        const ctx = canvas.getContext('2d')

        // 在Canvas上绘制图像并压缩
        ctx.drawImage(img, 0, 0, width, height)

        // 将Canvas数据转换为Base64编码
        const base64 = canvas.toDataURL('image/jpeg', quality)
        resolve(base64)
      }

      // 读取图像文件
      const reader = new FileReader()
      reader.onload = event => {
        img.src = event.target.result
      }

      reader.onerror = error => {
        reject(error)
      }

      reader.readAsDataURL(file)
    })
  },
  async baiduOcrIdCardImage(image, accessToken, type = 'front') {
    // if (type === 'front') {
    //   ocrCardNumber = '';
    // }
    const res = await fetch(`/baiduApi/rest/2.0/ocr/v1/idcard?access_token=${accessToken}`, {
      method: 'POST',
      headers: {
        // Content-Type	application/x-www-form-urlencoded
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: stringify({
        image: encodeURI(image),
        id_card_side: type
      })
    })

    if (res.status !== 200) {
      return false
    }
    const response = await res.json()
    if (response.error_code === 110) {
      Toast('百度 access_token 失效，请刷新页面重新获取', { type: 'fail' })
      return false
    }

    const result = util.checkBaiduOrc(response)

    if (result === true) {
      return response.words_result
    } else {
      Toast(result, { type: 'fail' })
    }
    return false
  },

  async baiduOcrBankImage(image, accessToken) {
    const res = await fetch(`/baiduApi/rest/2.0/ocr/v1/bankcard?access_token=${accessToken}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: stringify({
        image: encodeURI(image)
      })
    })

    if (res.status !== 200) {
      return false
    }
    const response = await res.json()
    if (response.error_code === 110) {
      Toast('百度 access_token 失效，请刷新页面重新获取', { type: 'fail' })
      return false
    }
    return response.result
  }
}

export default util
